import { all, fork } from 'redux-saga/effects';
import decisionsSaga from './db/decisions';
import userSaga from './db/user';
import modalSaga from './ui/modal';

export default function* rootSaga() {
  yield all([fork(modalSaga)]);
  yield all([fork(decisionsSaga)]);
  yield all([fork(userSaga)]);
}
